import moment from 'moment/moment';
import React, { useEffect, useState } from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { axiosInstance } from '../config';
import Loader from '../../common/Loader';

const SlotSelection = ({ timeSlot, setTimeSlot, id, selectedCource, slotsdata, InstructorCourse }) => {
    const [dateValue, setDateValue] = useState(new Date());
    // const [InstructorCourse, setInstructorCourse] = useState([]);
    // const [Loading, setLoading] = useState(false);
    // const [slotsdata, setSlots] = useState([]);

    const dailySlotDuration = 2; // Each slot duration in hours

    // useEffect(() => {
    //     getSessionsInfo();
    // }, [id]);

    // const getSessionsInfo = () => {
    //     setLoading(true);
    //     axiosInstance
    //         .get(`get-instlesson_slots/${id}`)
    //         .then((res) => {
    //             const lessons = res?.data?.data.filter((item) => item?.instacceptance !== "1") || [];
    //             setInstructorCourse(lessons);
    //             const fullWeekData = [ "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"].map((day) => {
    //                 const existingSlot = res?.data?.slots.find(slot => slot.days === day);
    //                 if (existingSlot) {
    //                   return existingSlot;  // If there's a slot for this day, keep the existing slot
    //                 } else {
    //                   return {
    //                     id: null,  // If no slot exists, set id to null
    //                     instructorid: id,
    //                     days: day,
    //                     slots: "[]",  // Empty array for slots
    //                     status: "1"
    //                   };
    //                 }
    //               });
    //             setSlots(fullWeekData)
    //         })
    //         .catch((err) => console.error(err))
    //         .finally(() => setLoading(false));
    // };

    const calculateEndDate = (startDate, totalHours) => {
        const daysRequired = Math.ceil(totalHours / dailySlotDuration); // Number of working days required
        let weekdaysCount = 0;
        let currentDate = moment(startDate);
        while (weekdaysCount < daysRequired) {
            if (currentDate.isoWeekday() < 6) { // Check if it's a weekday
                weekdaysCount++;
            }
            if (weekdaysCount < daysRequired) { // Only increment if more days are needed
                currentDate.add(1, 'days');
            }
        }
        return currentDate.toDate();
    };

    const isSlotBlocked = (selectedDate, slotTime) => {
        // Format the selected date as 'YYYY-MM-DD' (just the date, without time)
        const selectedDateStr = moment(selectedDate).format('YYYY-MM-DD');

        // Extract the start and end times from the slotTime (e.g., '10:00 AM - 12:00 PM')
        const [slotStartTime, slotEndTime] = slotTime.split(' - ');

        // Convert slot start and end times to Moment objects with the selected date
        const slotStart = moment(selectedDateStr + ' ' + slotStartTime, 'YYYY-MM-DD hh:mm A');
        const slotEnd = moment(selectedDateStr + ' ' + slotEndTime, 'YYYY-MM-DD hh:mm A');

        // Check if any lesson blocks the selected time slot
        return InstructorCourse.some((lesson) => {
            const lessonStartDate = moment(lesson.bookingdate).format('YYYY-MM-DD');
            const totalHours = Number(lesson?.cources?.theory) + Number(lesson?.cources?.practical);

            // Calculate the end date/time of the lesson
            const lessonEndDate = moment(calculateEndDate(lessonStartDate, totalHours)).format('YYYY-MM-DD');

            // Extract lesson start and end times (from the lesson's booking time)
            const [lessonStartTime, lessonEndTime] = lesson.bookingtime.split(' - ');

            // Loop through all dates between lessonStartDate and lessonEndDate to check for overlap
            let isBlocked = false;

            let currentLessonDate = moment(lessonStartDate);
            while (currentLessonDate.isSameOrBefore(lessonEndDate)) {
                // Generate the start and end time for the current day (same time slot each day)
                const currentDaySlotStart = moment(currentLessonDate.format('YYYY-MM-DD') + ' ' + lessonStartTime, 'YYYY-MM-DD hh:mm A');
                const currentDaySlotEnd = moment(currentLessonDate.format('YYYY-MM-DD') + ' ' + lessonEndTime, 'YYYY-MM-DD hh:mm A');

                // Check if the selected slot overlaps with the current day's lesson time
                const isDateOverlap = selectedDateStr === currentLessonDate.format('YYYY-MM-DD'); // Only check if the date matches
                const isTimeOverlap = slotStart.isBefore(currentDaySlotEnd) && slotEnd.isAfter(currentDaySlotStart); // Check if times overlap

                if (isDateOverlap && isTimeOverlap) {
                    isBlocked = true;
                    break; // No need to continue once we find an overlap
                }

                // Move to the next day
                currentLessonDate.add(1, 'days');
            }

            return isBlocked; // Return whether the slot is blocked for any day in the lesson's range
        });
    };

    const getAvailableSlots = (CurrentDate) => {
        const selectedDate = CurrentDate;
        const dayName = moment(CurrentDate).format("dddd") || [];  // Get the name of the selected day
        const slots = slotsdata.filter((slot) => slot.days === dayName);  // Filter slots by selected day
        console.log(dayName)
        // Parse the slots from JSON string to an array and filter out blocked slots
        const availableSlots = slots.flatMap((slot) => {
            const parsedSlots = slot?.slots ? JSON.parse(slot?.slots) : [];  // Parse the slots JSON string
            return parsedSlots.filter((parsedSlot) => {
                const slotTime = `${parsedSlot.start} - ${parsedSlot.end}`;
                return !isSlotBlocked(selectedDate, slotTime);  // Filter out blocked slots
            });
        });

        console.log("availableSlots", availableSlots)
        return availableSlots;
    };

    const availableSlots = getAvailableSlots(dateValue);

    const onDateChange = (e) => {
        setDateValue(e);
        setTimeSlot((prev) => ({
            ...prev,
            date: moment(e).format('YYYY-MM-DD'),
            time: ''
        }));
    };
    
    // useEffect(() => {
    //     if (timeSlot?.date)
    //         setDateValue(moment(timeSlot?.date, "DD-MM-YYYY").startOf('day').toDate())
    // }, [timeSlot])

    // Find the first available date
    const findFirstAvailableDate = () => {
        let currentDate = moment().startOf('day').toDate();  // Start from today

        for (let i = 0; i < 5; i++) {
            const availableSlots = getAvailableSlots(currentDate);  // Get available slots for the current date
            if (availableSlots.length > 0) {
                return currentDate;  // Return the first available date found
            }
            currentDate.setDate(currentDate.getDate() + 1);  // Increment the date by 1 day
        }
        return null;  // If no available slots are found in the next 30 days
    };

    // Use useEffect to find and set the first available date when the component is mounted
    useEffect(() => {
        const firstAvailableDate = findFirstAvailableDate();
        if (firstAvailableDate && slotsdata && !timeSlot?.time) {
            setDateValue(firstAvailableDate);  // Set the first available date
            setTimeSlot((prev) => ({
                ...prev,
                date: moment(firstAvailableDate).format('YYYY-MM-DD'), // Format the date correctly
                // time: '' // Reset the time
            }));
        }
    }, [slotsdata]);  // Empty dependency array to run this only on mount
 

    return (
        <div>
            {/* {Loading && <Loader />} */}
            <div>
                <h2 className="pt-3 pb-2 fs-2 fw-semibold">Book a time</h2>
                <p>
                    Just a few questions to determine the type of lesson or course you would like.
                </p>
            </div>

            <div className="row mt-4">
                <div className="col-md-6">
                    <div className="input-white-box d-block p-4">
                        <Calendar
                            onChange={onDateChange}
                            minDate={new Date()}
                            className="w-100"
                            value={timeSlot?.date || moment().format("DD-MM-YYYY")}
                        />
                    </div>
                </div>

                <div className="col-md-6">
                    {
                        availableSlots.length === 0 && (
                            <div
                                className={`input-white-box me-md-5 d-block px-4 `}
                            >
                                No Slots Available
                            </div>
                        )
                    }
                    {availableSlots.map((slot, index) => {
                        const curr_slot = `${moment(slot.start, "HH:mm").format("hh:mm A")} - ${moment(slot.end, "HH:mm").format("hh:mm A")}`;
                        const isSelected = curr_slot === timeSlot?.time;

                        return (
                            <div
                                key={index}
                                className={`input-white-box me-md-5 d-block px-4 py-3 ${isSelected ? 'bg-black2 text-white' : ''}`}
                                style={{ cursor: 'pointer' }}
                                onClick={() =>
                                    setTimeSlot((prev) => ({
                                        ...prev,
                                        time: curr_slot,
                                        location: slot.location,
                                        lesson_type: slot.lesson_type,
                                    }))
                                }
                            >
                                <div className="fw-semibold fs-6">
                                    <i className="bi bi-clock me-2"></i>
                                    {moment(slot.start, "HH:mm").format("hh:mm A")} - {moment(slot.end, "HH:mm").format("hh:mm A")}
                                </div>
                                <div className={`d-flex gap-3 mt-2 small ${isSelected ? 'text-white-50' : 'text-muted'}`}>
                                    <span>
                                        <i className="bi bi-geo-alt-fill me-1"></i>
                                        {slot.location}
                                    </span>
                                    <span>
                                        <i className="bi bi-car-front-fill me-1"></i>
                                        {slot.lesson_type}
                                    </span>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default SlotSelection;
